import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/startNowStyle.js";
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
const useStyles = makeStyles(styles);

export default function StartNow(props) {
  const { ...rest } = props;
  const classes = useStyles();
  const isTokenAvailable = (localStorage.getItem('token'));
  const registered =(localStorage.getItem('registered')=='true'?true:false)
  const ContactUs=()=>{
   // props.history.push("/ContactUs");
    window.location.href="http://sharifcamp.ir/ContactUs"

  }
  const Register=()=>{
   // props.history.push("/SendCode");
    window.location.href="http://sharifcamp.ir/SendCode"
    
  }
  const Profile=()=>{
   // props.history.push("/Profile");
    window.location.href="http://sharifcamp.ir/Profile"
    
  }
  return (
    <div className={classes.section}>
      <GridContainer justify="center" >
        <GridItem xs={12} sm={12} md={8}>
        <Paper variant="outlined" >
          <div className={classes.Box}>
        <Typography variant="h5" gutterBottom>
        همین حالا شروع کنید!

      </Typography>
      <Typography variant="overline" gutterBottom>
    در صورت وجود هرگونه سوال یا ابهام با ما تماس بگیرید.
      </Typography>
      <div>
      <Button variant="outlined" onClick={ContactUs} color="primary">
  تماس با ما
</Button> {"  "}
{ isTokenAvailable==null || registered==false ? (
        <span>
         <Button variant="contained" onClick={Register} color="primary" disableElevation>
  ثبت نام
</Button>
</span>
      ) :(
        <Button variant="contained" onClick={Profile} color="primary" disableElevation>
            پروفایل کاربری
</Button>
      )}

      </div>
      </div>
          </Paper>
        </GridItem>
      </GridContainer>
    </div>
  );
}
